exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadty-disabled .ant-upload-list-item .anticon-close {\n  display: none;\n}\n.uploadty-disabled .ant-upload-list-item .anticon-delete {\n  display: none;\n}\n.uploadty-mover-mask {\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0.8;\n  color: #fff;\n  height: 28px;\n  line-height: 28px;\n}\n", ""]);

// exports
